"use client";
import React from "react";
import type { PricingPlan } from "@/types/sections/pricing";
import type { Props } from "@/components/pricing";
import { paddingMap } from "@/components/pricing";
import { getBackgroundStyle, getBtnVariant } from "@/lib/background";
import { Button } from "@/components/ui/button";

export default function PricingFeatured({ data }: Props) {
  const {
    title,
    subtitle,
    plans = [],
    background,
    padding = "xl",
  } = data || {};

  const bgStyle = getBackgroundStyle(background);

  // Phân loại gói nổi bật và gói còn lại
  const featuredPlan = plans.find((p) => p.highlighted) || plans[1] || plans[0];
  const otherPlans = plans.filter((p) => p !== featuredPlan);

  return (
    <section
      className={`${paddingMap[padding] || "py-20 px-6"}`}
      style={bgStyle}
    >
      <div className="max-w-7xl mx-auto text-center">
        {title && (
          <h2 className="text-4xl font-bold mb-4 text-foreground">{title}</h2>
        )}
        {subtitle && (
          <p className="text-lg text-muted-foreground mb-10">{subtitle}</p>
        )}

        <div className="grid md:grid-cols-3 gap-6 items-start">
          {otherPlans[0] && <PricingCard plan={otherPlans[0]} />}

          <div className="transform scale-105 shadow-xl z-10 relative">
            <PricingCard plan={featuredPlan} isFeatured />
          </div>

          {otherPlans[1] && <PricingCard plan={otherPlans[1]} />}
        </div>
      </div>
    </section>
  );
}

function PricingCard({
  plan,
  isFeatured = false,
}: {
  plan: PricingPlan;
  isFeatured?: boolean;
}) {
  return (
    <div
      className={`border rounded-lg p-6 transition bg-white ${
        isFeatured ? "border-primary ring-2 ring-primary" : "border-gray-200"
      }`}
    >
      <h3 className="text-xl font-semibold mb-1">{plan.name}</h3>
      <p className="text-muted-foreground mb-4">{plan.description}</p>
      <div className="text-3xl font-bold mb-4">
        {plan.currency || "$"}
        {plan.price?.monthly ?? 0}
        <span className="text-sm text-muted-foreground"> /mo</span>
      </div>
      <ul className="mb-6 text-left text-sm space-y-2 text-foreground">
        {plan.features?.map((feature: string, i: number) => (
          <li key={i}>• {feature}</li>
        ))}
      </ul>
      {plan.button?.href && plan.button?.text && (
        <Button
          asChild
          variant={getBtnVariant(plan.button.style)} // dùng mặc định nếu thiếu
          // className="px-5 py-2 text-sm font-medium"
        >
          <a href={plan.button.href}>{plan.button.text}</a>
        </Button>
      )}
    </div>
  );
}
